export const ENGAGEMENT_EVENT_TYPES = Object.freeze({
  ACCOUNT_CREATED: "account_created",
  LOGIN: "login",
  LOGOUT: "logout",
  PRESENTATION_STARTED: "presentation_started",
  PRESENTATION_ENDED: "presentation_ended",
  PRESENTATION_HEARTBEAT: "presentation_heartbeat",
  CLASS_CREATED: "class_created",
  CLASS_DELETED: "class_deleted",
  CONTENT_CREATED: "content_created",
  CONTENT_UPDATED: "content_updated",
  ANNOUNCEMENT_CREATED: "announcement_created",
  SCHEDULE_CREATED: "schedule_created",
  SCHEDULE_UPDATED: "schedule_updated",
  AUTOMATION_ENABLED: "automation_enabled",
  AUTOMATION_DISABLED: "automation_disabled",
  AUTO_CLASS_CHANGE_ENABLED: "auto_class_change_enabled",
  MUSIC_STARTED: "music_started",
  TIMER_STARTED: "timer_started",
  TIMER_COMPLETED: "timer_completed",
  BIRTHDAY_TRIGGERED: "birthday_triggered",
  SHARE_LINK_CREATED: "share_link_created",
  ACTIVE_DATES_ENABLED: "active_dates_enabled",
  ACTIVE_DATES_EDUCATION_MODAL_OPENED: "active_dates_education_modal_opened",
  ACTIVE_DATES_EDUCATION_VIDEO_PROCEEDED: "active_dates_education_video_proceeded",
  ACTIVE_DATES_EDUCATION_VIDEO_REVISITED: "active_dates_education_video_revisited",
  ACTIVE_DATES_EDUCATION_UNDERSTANDING_IMPRESSION: "active_dates_education_understanding_impression",
  ACTIVE_DATES_EDUCATION_UNDERSTANDING_UNDERSTANDS: "active_dates_education_understanding_understands",
  ACTIVE_DATES_EDUCATION_UNDERSTANDING_STARTING: "active_dates_education_understanding_starting",
  ACTIVE_DATES_EDUCATION_UNDERSTANDING_CONFUSED: "active_dates_education_understanding_confused",
  RANDOMIZER_USED: "randomizer_used",
  WHITEBOARD_USED: "whiteboard_used",
  GOOGLE_SLIDES_USED: "google_slides_used",
  PDF_USED: "pdf_used",
  MULTIBOX_USED: "multibox_used",
  AGENDA_USED: "agenda_used",
  TEMPLATE_APPLIED: "template_applied",
  ROSTER_UPDATED: "roster_updated",
  UPGRADE_PROMPT_IMPRESSION: "upgrade_prompt_impression",
  UPGRADE_PROMPT_CLICK: "upgrade_prompt_click",
  TRIAL_STARTED: "trial_started",
  TRIAL_EXPIRING: "trial_expiring",
  SUBSCRIPTION_CREATED: "subscription_created",
  SUBSCRIPTION_RENEWED: "subscription_renewed",
  SUBSCRIPTION_CANCELED: "subscription_canceled",
  SUBSCRIPTION_PAUSED: "subscription_paused",
  PAYMENT_FAILED: "payment_failed",
  LIVE_OFFICE_HOURS_STARTED: "live_office_hours_started",
  LIVE_OFFICE_HOURS_ENDED: "live_office_hours_ended",
  LIVE_OFFICE_HOURS_EXTENDED: "live_office_hours_extended",
  LIVE_OFFICE_HOURS_BANNER_VIEWED: "live_office_hours_banner_viewed",
  LIVE_OFFICE_HOURS_JOIN_CLICKED: "live_office_hours_join_clicked",
  LIVE_OFFICE_HOURS_BANNER_DISMISSED: "live_office_hours_banner_dismissed",
  LEARNING_CENTER_VIEWED: "learning_center_viewed",
  LEARNING_SESSION_VIEWED: "learning_session_viewed",
  LEARNING_SESSION_REGISTERED: "learning_session_registered",
  LEARNING_SESSION_JOIN_CLICKED: "learning_session_join_clicked",
  MOBILE_SIGNUP_HANDOFF_VIEWED: "mobile_signup_handoff_viewed",
  MOBILE_REMINDER_OPTION_SELECTED: "mobile_reminder_option_selected",
  MOBILE_REMINDER_SCHEDULED: "mobile_reminder_scheduled",
  MOBILE_REMINDER_RESCHEDULED: "mobile_reminder_rescheduled",
  MOBILE_REMINDER_SKIPPED: "mobile_reminder_skipped",
  MOBILE_CONTINUE_ON_DEVICE_SELECTED: "mobile_continue_on_device_selected",
  MOBILE_CONTINUE_ON_DEVICE_CONFIRMED: "mobile_continue_on_device_confirmed",
  MOBILE_REMINDER_SENT: "mobile_reminder_sent",
  MOBILE_REMINDER_CANCELED: "mobile_reminder_canceled",
  MOBILE_REMINDER_CLICKED: "mobile_reminder_clicked",
  DESKTOP_RETURN_AFTER_MOBILE_SIGNUP: "desktop_return_after_mobile_signup",
  ACTIVATION_AFTER_MOBILE_SIGNUP: "activation_after_mobile_signup",
  AI_CLASS_SCHEDULE_SETUP_OPENED: "ai_class_schedule_setup_opened",
  AI_CLASS_SCHEDULE_SOURCE_SUBMITTED: "ai_class_schedule_source_submitted",
  AI_CLASS_SCHEDULE_ANALYSIS_COMPLETED: "ai_class_schedule_analysis_completed",
  AI_CLASS_SCHEDULE_ANALYSIS_FAILED: "ai_class_schedule_analysis_failed",
  AI_CLASS_MATCH_CHANGED: "ai_class_match_changed",
  AI_CLASS_SCHEDULE_CLARIFICATION_ANSWERED: "ai_class_schedule_clarification_answered",
  AI_CLASS_SCHEDULE_DRAFT_EDITED: "ai_class_schedule_draft_edited",
  AI_CLASS_SCHEDULE_APPLY_STARTED: "ai_class_schedule_apply_started",
  AI_CLASS_SCHEDULE_APPLY_COMPLETED: "ai_class_schedule_apply_completed",
  AI_CLASS_SCHEDULE_APPLY_FAILED: "ai_class_schedule_apply_failed",
  AI_CLASS_SCHEDULE_SETUP_UNDONE: "ai_class_schedule_setup_undone",
  WEB_BOX_EXTERNAL_WIDGET_PROVIDER_CLICKED: "web_box_external_widget_provider_clicked",
  AI_CLASS_SCHEDULE_FEEDBACK_SUBMITTED: "ai_class_schedule_feedback_submitted",
});

export const LEGACY_EVENT_ALIASES = Object.freeze({
  present_start: ENGAGEMENT_EVENT_TYPES.PRESENTATION_STARTED,
  present_end: ENGAGEMENT_EVENT_TYPES.PRESENTATION_ENDED,
  present_heartbeat: ENGAGEMENT_EVENT_TYPES.PRESENTATION_HEARTBEAT,
  countdown_used: ENGAGEMENT_EVENT_TYPES.TIMER_STARTED,
  music_used: ENGAGEMENT_EVENT_TYPES.MUSIC_STARTED,
  birthday_used: ENGAGEMENT_EVENT_TYPES.BIRTHDAY_TRIGGERED,
  share_page_used: ENGAGEMENT_EVENT_TYPES.SHARE_LINK_CREATED,
});

export const ENGAGEMENT_EVENT_TYPE_SET = new Set([
  ...Object.values(ENGAGEMENT_EVENT_TYPES),
  ...Object.keys(LEGACY_EVENT_ALIASES),
]);

export function normalizeEventType(eventType) {
  return LEGACY_EVENT_ALIASES[eventType] || eventType;
}

export const FEATURE_EVENT_TYPES = Object.freeze({
  randomizer: ENGAGEMENT_EVENT_TYPES.RANDOMIZER_USED,
  birthday: ENGAGEMENT_EVENT_TYPES.BIRTHDAY_TRIGGERED,
  music: ENGAGEMENT_EVENT_TYPES.MUSIC_STARTED,
  whiteboard: ENGAGEMENT_EVENT_TYPES.WHITEBOARD_USED,
  googleSlides: ENGAGEMENT_EVENT_TYPES.GOOGLE_SLIDES_USED,
  pdf: ENGAGEMENT_EVENT_TYPES.PDF_USED,
  multibox: ENGAGEMENT_EVENT_TYPES.MULTIBOX_USED,
  sharePage: ENGAGEMENT_EVENT_TYPES.SHARE_LINK_CREATED,
  agenda: ENGAGEMENT_EVENT_TYPES.AGENDA_USED,
  timer: ENGAGEMENT_EVENT_TYPES.TIMER_STARTED,
  autoClassChange: ENGAGEMENT_EVENT_TYPES.AUTO_CLASS_CHANGE_ENABLED,
  activeDates: ENGAGEMENT_EVENT_TYPES.ACTIVE_DATES_ENABLED,
});

export const ENGAGEMENT_PLATFORMS = Object.freeze({
  DESKTOP: "desktop",
  TABLET: "tablet",
  MOBILE: "mobile",
});

export const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;

export const INACTIVITY_THRESHOLD_MS = 10 * 60 * 1000;
